export const BUILD_INFO = { sha: 'a4a1d0f' };
